export interface Product {
  id: string;
  name: string;
  description: string;
  sku: string;
  status: ProductStatus;
  mainImageUrl: string;
  attributes: ProductAttribute[];
  brandId: string;
  brandName: string;
  categoryId: string;
  categoryName: string;
  modelId: string;
  modelName: string;
  modelVersionId: string;
  modelVersionName: string;
  images: ProductImage[];
}

export interface ProductList {
  id: string;
  name: string;
  description?: string;
  sku: string;
  status: ProductStatus;
  mainImageUrl: string;
  attributes: ProductAttribute[];
  modelVersionId: string;
  modelVersionName: string;
}

export interface CreateProduct {
  name: string;
  description?: string;
  sku: string;
  status: ProductStatus;
  images: ProductImage[];
  attributes: ProductAttribute[];
  modelVersionId: string;
}

export interface UpdateProduct {
  id: string;
  name: string;
  description?: string;
  status: ProductStatus;
  images: ProductImage[];
  attributes: ProductAttribute[];
}

export enum ProductStatus {
  Draft = 1,
  Active = 2,
  Inactive = 3,
}

export interface ProductImage {
  id?: string;
  image: File;
  sortOrder: number;
  imageFileId?: string;
  imageUrl?: string;
}

export interface ProductAttribute {
  variationAttributeId: string;
  variationAttributeName: string;
  variationAttributeValueId: string;
  variationAttributeValue: string;
}
